import React, { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import "./TabsComponent.css";

/**
 * Reusable Tabs Component
 * 
 * @param {Array} tabs - Array of tab objects: [{ key, title, content, disabled }]
 * @param {string} defaultKey - Default active tab key
 * @param {string} className - Optional extra CSS classes
 */
const TabsComponent = ({ tabs = [], defaultKey = "", className = "" }) => {
  const [activeKey, setActiveKey] = useState(defaultKey || (tabs[0]?.key || ""));

  return (
    <Tabs
      id="custom-tabs"
      activeKey={activeKey}
      onSelect={(k) => setActiveKey(k)}
      className={`custom-tabs mb-3 ${className}`}
    >
      {tabs.map((tab) => (
        <Tab
          key={tab.key}
          eventKey={tab.key}
          title={tab.title}
          disabled={tab.disabled || false}
          className="mx-3 pb-3"
        >
          {tab.content}
        </Tab>
      ))}
    </Tabs>
  );
};

export default TabsComponent;
